import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { getSession } from "../../utils/session";

const KPISubHeader = () => {
    const location = useLocation();
    const [executionDate, setExecutionDate] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [roleId, setRoleId] = useState(null);

    // Get role from session
    useEffect(() => {
        const session = getSession();
        if (session?.roleId) setRoleId(session.roleId);
    }, []);

    // Fetch last execution date
    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await fetch('https://api-project360-insights.haqdarshak.com/api/last-execution-date/');
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                const data = await response.json();
                setExecutionDate(data.last_execution_date);
            } catch (err) {
                setError(err.message);
                console.error('Failed to fetch execution date:', err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return null;
        try {
            const date = new Date(dateString.replace(' AM', ''));
            return date.toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        } catch (e) {
            return dateString;
        }
    };

    return (
        <div className="fixed top-[7vh] left-0 right-0 z-40 bg-gray-50 border-b border-gray-200 shadow-sm">
            <div className="flex justify-between items-center px-6">
                <div className="ml-[30vw] flex flex-row gap-2 py-2 text-sm font-medium">

                    <Link
                        to="/Project-Level"
                        className={`px-3 py-1 rounded-md transition-colors ${
                            location.pathname === "/Project-Level" 
                                ? "bg-indigo-600 text-white shadow-sm" 
                                : "text-gray-600 hover:bg-gray-100"
                        }`}
                    >
                        Project Level
                    </Link>

                    <Link
                        to="/Project-Scheme-Diversity"
                        className={`px-3 py-1 rounded-md transition-colors ${
                            location.pathname === "/Project-Scheme-Diversity" 
                                ? "bg-indigo-600 text-white shadow-sm" 
                                : "text-gray-600 hover:bg-gray-100"
                        }`}
                    >
                        Scheme Diversity
                    </Link>

                    {/* HIDE FOR ROLE 28 */}
                    {roleId !== 28 && (
                        <Link
                            to="/Project-KPI-Comparison"
                            className={`px-3 py-1 rounded-md transition-colors ${
                                location.pathname === "/Project-KPI-Comparison" 
                                    ? "bg-indigo-600 text-white shadow-sm" 
                                    : "text-gray-600 hover:bg-gray-100"
                            }`}
                        >
                            Comparison
                        </Link>
                    )}
                </div>
                
                {/* Last Update */}
                <div className="flex items-center text-sm text-black">
                    {isLoading ? (
                        <div className="flex items-center">
                            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-400 mr-1"></div>
                            <span>Loading update...</span>
                        </div>
                    ) : error ? (
                        <div className="flex items-center text-red-500">
                            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>Update failed</span>
                        </div>
                    ) : (
                        <div className="flex items-center">
                            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span> Data Last Updated At: {formatDate(executionDate)}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default KPISubHeader;